import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import LegalContent from './section-components/legal-content';
import Footer from './global-components/footer-v2';

const RefundAndCancellationPolicy = () => {
	const content = {
		kicker: 'Converzex — Subscription and Payment Policy',
		meta: 'Effective Date: August 14, 2026 | Last Updated: August 14, 2026',
		sections: [
			{
				id: 'overview',
				title: '1. Overview',
				paragraphs: [
					'This policy explains how Converzex handles subscriptions, cancellations, refunds, usage charges, trials, and payment issues.'
				]
			},
			{
				id: 'free-trial',
				title: '2. Free Trial',
				paragraphs: [
					'Converzex offers a 7-day free trial for new customers. You can cancel at any time during the trial at no charge. If you do not cancel before the trial ends, your selected package will be charged.'
				]
			},
			{
				id: 'subscription-cancellation',
				title: '3. Subscription Cancellation',
				paragraphs: [
					'You may cancel through the cancellation option available in your account or by contacting our support team.',
					'Cancellation stops future renewal, and the Services normally remain available until the end of the current paid billing period. Cancelling does not automatically create a refund for unused time.'
				]
			},
			{
				id: 'subscription-refunds',
				title: '4. Subscription Refunds',
				paragraphs: [
					'Because Converzex is a digital software service, subscription fees are generally non-refundable once a billing period has started, except where a refund is required by law or Converzex approves a refund or credit.',
					'Specific packages, promotional offers, orders, or written agreements may have different refund terms.'
				]
			},
			{
				id: 'usage-charges',
				title: '5. Usage Charges',
				paragraphs: [
					'Usage-based charges may include voice minutes, calls, messages, AI credits, or other metered features. Charges for usage that has already occurred are generally non-refundable.'
				]
			},
			{
				id: 'setup-onboarding',
				title: '6. Setup, Onboarding, and Custom Services',
				paragraphs: [
					'Implementation, onboarding, configuration, custom development, consulting, and other professional services may have separate fees and terms. These fees are generally non-refundable once work has started unless otherwise agreed in writing.'
				]
			},
			{
				id: 'duplicate-charges',
				title: '7. Duplicate or Incorrect Charges',
				paragraphs: [
					'If you believe you were charged twice, charged for a service you did not purchase, or charged the wrong amount, contact us with the invoice or transaction details. We will review confirmed billing errors and make the appropriate correction.'
				]
			},
			{
				id: 'failed-payments',
				title: '8. Failed Payments',
				paragraphs: [
					'If a payment fails, we may retry the payment or request another payment method. Continued non-payment may result in restricted or suspended access to paid Services.'
				]
			},
			{
				id: 'request-refund',
				title: '9. How to Request a Refund',
				paragraphs: [
					<>Send refund requests to <a href="mailto:legal@converzex.com">legal@converzex.com</a> and include:</>
				],
				list: [
					'Account email address',
					'Invoice or transaction number',
					'Date and amount of the charge',
					'Reason for the request',
					'Any supporting information'
				]
			},
			{
				id: 'refund-review',
				title: '10. Refund Review',
				paragraphs: [
					'We review refund requests based on the applicable package, purchase terms, usage, billing history, and applicable law. We aim to respond within 5 business days.',
					'Approval of one refund does not mean future requests will automatically be approved.'
				]
			},
			{
				id: 'approved-refunds',
				title: '11. Approved Refunds',
				paragraphs: [
					'Approved refunds are normally sent to the original payment method within 5–10 business days. The final timing depends on the payment processor, card issuer, bank, or other financial institution.'
				]
			},
			{
				id: 'chargebacks',
				title: '12. Chargebacks',
				paragraphs: [
					'Before starting a chargeback, we encourage customers to contact us so we can review the billing issue. If a chargeback is opened, we may provide relevant account and transaction information to the payment processor or financial institution handling the dispute.'
				]
			},
			{
				id: 'changes',
				title: '13. Changes to This Policy',
				paragraphs: [
					'We may update this policy when our pricing, packages, payment methods, or Services change. The latest version will be published on the Converzex website.'
				]
			},
			{
				id: 'contact',
				title: '14. Contact',
				paragraphs: [
					<>For cancellation, billing, or refund questions, contact <a href="mailto:legal@converzex.com">legal@converzex.com</a> or visit <a href="https://www.converzex.com" target="_blank" rel="noopener noreferrer">www.converzex.com</a></>
				]
			}
		]
	};

	return (
		<div>
			<Navbar />
			<PageHeader headertitle="Refund and Cancellation Policy" />
			<LegalContent {...content} />
			<Footer />
		</div>
	);
};

export default RefundAndCancellationPolicy;
